import '../styles/dashboard.scss'
import Loader from '../Shared/Loader'
import Confetti from 'react-confetti'
import { Scoreboard } from '../components/Scoreboard'
import {
  MiniMenu,
  PassedDownProps as MiniMenuProps,
} from '../components/MiniMenu'
// @ts-ignore
import sunday from '../assets/sunday.png'
import { TargetScoresProps, TargetScores } from '../components/TargetScores'
import { useState } from 'react'
import { Moment } from 'moment'
import EditTargetsDialog, {
  TargetChangeHandler,
} from '../components/EditTargetsDialog'
import { dateFormat } from '../utils/constants'
import { DaySwitcherProps, DaySwitchers } from '../components/DaySwitchers'
import { Target } from '../utils/dataFormatting'
import { Profile } from './Profile'
import { CharityIcon } from '../components/CharityIcon'
import {
  ChangePasswordDialog,
  ChangePasswordFunc,
} from '../components/ChangePasswordDialog'
import { Headline, HeadlinesBanner } from '../components/HeadlinesBanner'
import { Player } from '../types'
import { InviteDialog } from '../components/InviteDialog'
import { Alert, Snackbar } from '@mui/material'

export const LogoutButton = ({ onClick }: any) => {
  return (
    <button className="prev log" onClick={onClick}>
      Logout
    </button>
  )
}

const headerStyle = {
  position: 'relative',
  margin: '5px 0px',
  width: '100%',
}

const sundayContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  margin: '20px 0px',
  overflow: 'hidden',
}

export interface DashboardContentsProps
  extends TargetScoresProps,
    MiniMenuProps,
    DaySwitcherProps {
  selectedDay: Moment
  dayOffset: number
  headlines?: Headline[]
  onChangeTargets: TargetChangeHandler
  onChangePassword: ChangePasswordFunc
  players: Player[]
  isUploadingVideo: boolean
  [key: string]: any
}

export const DashboardContents = ({
  isCelebrating,
  selectedDay,
  dayOffset,
  headlines,
  onGoBackADay,
  onGoForwardADay,
  isLoading,
  isUploadingVideo,
  habits,
  targets,
  players,
  onChangeTargets,
  onChangePassword,
  roundStartDay,
  onLogout,
  teammate,
  ...props
}: DashboardContentsProps) => {
  const [isShowingInviteDialog, setIsShowingInviteDialog] = useState(false)
  const [isShowingProfile, setIsShowingProfile] = useState(false)
  const [isShowingEditTargetsDialog, setIsShowingEditTargetsDialog] =
    useState(false)
  const [isShowingPasswordDialog, setIsShowingPasswordDialog] = useState(false)
  const [isAlerting, setIsAlerting] = useState(false)
  const [alertText, setAlertText] = useState("")

  const { innerWidth: width, innerHeight: height } = window

  const handleChangeTargets = async (targets: Target[]) => {
    setIsShowingEditTargetsDialog(false)
    await onChangeTargets(targets)
  }

  const handleInviteSent = () => {
    setIsAlerting(true)
    setAlertText("Invite sent!")
    setIsShowingInviteDialog(false)
  }

  return (
    <div>
      <div className="dashboard-container">
        <header>The Habits Game Tracker 🚀</header>
        {isCelebrating ? (
          <Confetti
            width={width}
            height={height}
            recycle={false}
            numberOfPieces={1000}
          />
        ) : null}
        <div className="dashboard-body">
          <div style={headerStyle as any}>
            <CharityIcon
              player={props.dashboardData.player}
              url={props.dashboardData.player.charityIconUrl}
            />
            <h1>{selectedDay.format(dateFormat)}</h1>
            <MiniMenu
              onSendInvite={() => setIsShowingInviteDialog(true)}
              onViewProfile={() => setIsShowingProfile(true)}
              roundStartDay={roundStartDay}
              onEditTargets={() => setIsShowingEditTargetsDialog(true)}
              onChangePassword={() => setIsShowingPasswordDialog(true)}
              onLogout={onLogout}
            />
          </div>

          {(!habits.length || isLoading) &&
            <Loader withBackDrop={isUploadingVideo} />}

          {selectedDay.weekday() !== 0 ? (
            <TargetScores {...props} day={selectedDay} />
          ) : (
            <div style={sundayContainerStyle}>
              <img style={{ width: '100%' }} src={sunday} alt="" />
            </div>
          )}
          <DaySwitchers
            selectedDay={selectedDay}
            dayOffset={dayOffset}
            roundStartDay={roundStartDay}
            onGoBackADay={onGoBackADay}
            onGoForwardADay={onGoForwardADay}
          />
          {headlines && <HeadlinesBanner headlines={headlines} />}
          <Scoreboard players={players} />
        </div>
      </div>
      {isShowingInviteDialog && (
        <InviteDialog
          onSubmit={() => handleInviteSent()}
          onClose={() => setIsShowingInviteDialog(false)}
        />
      )}
      {isShowingProfile && (
        <Profile
          playerId={props.dashboardData.player.id}
          onClose={() => setIsShowingProfile(false)}
        />
      )}
      {isShowingEditTargetsDialog && (
        <EditTargetsDialog
          isOpen={isShowingEditTargetsDialog}
          initialTargets={props.dashboardData.targets}
          onChangeTargets={handleChangeTargets}
          onClose={() => setIsShowingEditTargetsDialog(false)}
        />
      )}
      {isShowingPasswordDialog && (
        <ChangePasswordDialog
          onSubmitPassword={onChangePassword}
          onClose={() => setIsShowingPasswordDialog(false)}
        />
      )}
      <Snackbar
        open={isAlerting}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={4000}
        onClose={() => setIsAlerting(false)}
      >
        <Alert onClose={() => setIsAlerting(false)}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  )
}
